var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: _vm.sectionClass }, [
    _c("div", { staticClass: "section-content" }, [
      _c("div", { staticClass: "columns is-valigned-end" }, [
        _c("div", { staticClass: "column column-app-phone1" }, [
          _c(
            "p",
            {
              staticClass: "subtitle no-line-break-mobile",
              staticStyle: {
                width: "100%",
                "max-width": "90vw",
                "margin-bottom": "1rem",
                "font-size": "1.5rem",
              },
            },
            [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("home.section_intro.app_name"))),
              ]),
            ]
          ),
          _c("p", { staticClass: "subtitle no-line-break-mobile" }, [
            _vm._v(
              _vm._s(_vm.$t("home.section_intro.title1") + " ") +
                "\n" +
                _vm._s(_vm.$t("home.section_intro.title2"))
            ),
          ]),
          _c(
            "div",
            { staticClass: "is-hidden-mobile", staticStyle: { width: "100%" } },
            [_c("intro-partners")],
            1
          ),
        ]),
        _vm.itLang
          ? _c("div", { staticClass: "column is-narrow column-app-phone2" }, [
              _c("img", {
                staticClass: "block",
                attrs: {
                  src: "/img/phone-it.png",
                  alt: _vm.$t("alt.app"),
                  draggable: "false",
                },
              }),
            ])
          : _c("div", { staticClass: "column is-narrow column-app-phone2" }, [
              _c("img", {
                staticClass: "block",
                attrs: {
                  src: "/img/phone-en.png",
                  alt: _vm.$t("alt.app"),
                  draggable: "false",
                },
              }),
            ]),
        _c(
          "div",
          { staticClass: "column no-padding-top is-hidden-tablet" },
          [_c("intro-partners")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }